import type { FilterFieldDef, FilterSurface } from './types'
import { Switch } from '@/components/ui/switch'

interface ToggleFilterOptions {
    label: () => string
    /**
     * Giá trị ghi vào URL khi bật. **Phải là một từ**, không được dùng `'1'`
     * hay `'true'`: TanStack bọc nháy mọi chuỗi parse được thành số/boolean để
     * phân biệt kiểu, ra URL `?x=%221%22` vừa xấu vừa không gõ tay được.
     * Mặc định `'yes'`; API cần `'1'` thì màn tự map lúc gọi.
     */
    onValue?: string
}

/**
 * Bộ lọc bật/tắt. Chỉ có hai trạng thái nên KHÔNG sinh chip riêng — nhãn chip
 * mặc định (`"<label>: <giá trị>"`) đọc rất kỳ; badge đếm là đủ để người dùng
 * biết còn bộ lọc đang bật, và mở sheet ra thấy ngay công tắc.
 */
export function toggleFilter({
    label,
    onValue = 'yes',
}: ToggleFilterOptions): FilterFieldDef<string> {
    return {
        defaultValue: '',
        label,
        parse: (raw) => (raw === onValue ? onValue : undefined),
        chipLabel: () => label(),
        render: ({
            id,
            value,
            onChange,
            surface,
        }: {
            id: string
            value: string
            onChange: (next: string) => void
            surface: FilterSurface
        }) => (
            <div
                className={
                    surface === 'bar'
                        ? 'flex h-9 items-center'
                        : 'flex h-11 items-center'
                }
            >
                <Switch
                    id={id}
                    checked={value === onValue}
                    onCheckedChange={(checked) =>
                        onChange(checked ? onValue : '')
                    }
                />
            </div>
        ),
    }
}
